import React from "react";
import BaseModal from "@components/modals/BaseModal";
import Button from "@components/ui/buttons/Button";
import Icon1 from "@assets/icons/Icon";

interface ErrorModalProps {
  title?: string;
  type?: string;
  reason?: string;
  solutions?: string[];
  onClose: () => void;
  onOpenSupport?: () => void;
}

export default function ErrorModal({
  title = "Une erreur est survenue.",
  type = "Erreur d'authentification",
  reason = "",
  solutions = [],
  onClose,
  onOpenSupport,
}: ErrorModalProps) {
  return (
    <BaseModal
      title="Une erreur est survenue"
      startIcon={<Icon1 name="warning" size={20} color="black"></Icon1>}
      onClose={onClose}
      width="max-w-500"
    >
      <div className="flex flex-col w-400 gap-2 text-h2 bg-neutral-50 p-3 border-b-1">
        <div className="text-red-500">[{type}]</div>
        <div className="text-black">{reason} </div>

        {solutions?.length > 0 && (
          <div className="text-gray-500 block ">
            Solutions possibles :
            <div className="flex flex-col ml-4">
              {solutions.map((solution, index) => (
                <div key={index} className="inline">
                  - {solution}{" "}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      <div className="flex flex-row justify-end gap-2.5 p-3">
        <Button
          variant="small"
          label="Demander de l'aide"
          onClick={onOpenSupport}
        />
      </div>
    </BaseModal>
  );
}
